import type {
  AccordionStylesNames,
  CSSObject,
  MantineTheme,
} from '@mantine/core';
import { Accordion } from '@mantine/core';

import type { FindOneVaultSearchResponseDTO } from '../../../../../shared/api/magellan/vaultSearch/dto';
import { getUniqueDocumentIdString } from '../utils/vaultSearchUtils';
import { VaultSearchResultItem } from './VaultSearchResultItem';

export function VaultSearchResultList({
  searchData,
}: {
  searchData: FindOneVaultSearchResponseDTO;
}) {
  const { results } = searchData;

  return (
    <Accordion
      chevronPosition="right"
      variant="separated"
      multiple
      styles={accordionStyles}
    >
      {results.map(result => (
        <VaultSearchResultItem key={getUniqueDocumentIdString(result)} result={result} />
      ))}
    </Accordion>
  );
}

function accordionStyles(
  theme: MantineTheme,
): Partial<Record<AccordionStylesNames, CSSObject>> {
  const border = `1px solid ${theme.colors.gray[0]}`;

  return {
    item: {
      padding: theme.spacing['03'],
      backgroundColor: 'transparent',
      borderRadius: '12px',
      border,
      background: theme.colors.white,
      marginTop: `${theme.spacing['02']} !important`,
      '&[data-active]': {
        boxShadow: theme.shadows.sm,
        border,
      },
      '&:first-of-type': {
        marginTop: '0 !important',
      },
    },
    control: { padding: 0 },
    label: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing['01'],
    },
    chevron: {
      borderRadius: '8px',
      width: '26px',
      height: '26px',
      border,
      transform: 'rotate(-90deg)',
    },
    content: {
      padding: 0,
      paddingTop: theme.spacing['02'],
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing['01'],
    },
  };
}
